<script setup lang="ts">
import { stateShortNames } from '@/utils/PortalConstants';
import TablePageFooter from '@/components/footers/TablePageFooter.vue';
import ExportAsCsvIconBtn from '@/components/iconBtns/ExportAsCsvIconBtn.vue';
import SimpleLoader from '@/components/loaders/SimpleLoader.vue';
import WeeklyReportSearchForm from '@/components/searchForms/WeeklyReportSearchForm.vue';
import WeeklyReportTable from '@/components/tables/WeeklyReportTable.vue';
import FormWrapper from '@/components/wrappers/FormWrapper.vue';
import PageContentWrapper from '@/components/wrappers/PageContentWrapper.vue';
import TablePageShadowWrapper from '@/components/wrappers/TablePageShadowWrapper.vue';
import useCommonRouteQuery from '@/composables/routeQueries/useCommonRouteQuery';
import useCurrentDateString from '@/composables/useCurrentDateString';
import useDownloadCsv from '@/composables/useDownloadCsv';
import useWeeklyReportView from '@/composables/views/useWeeklyReportView';

const { getLastSevenDaysRange } = useCurrentDateString();
const { queryDates, queryStates } = useCommonRouteQuery({
  queryDates: getLastSevenDaysRange(),
  queryStates: stateShortNames,
});
const { downloadCsv } = useDownloadCsv();
const { search, initialData, isFetchingData, statsReport } =
  useWeeklyReportView(queryDates, queryStates);
</script>

<template>
  <div :class="$style.weeklyReportView" data-testid="weeklyReportView">
    <PageContentWrapper>
      <FormWrapper :class="$style.formWrapper">
        <WeeklyReportSearchForm
          :initial-data="initialData"
          :loading="isFetchingData"
          :class="$style.form"
          @submit="search"
        />
      </FormWrapper>
      <template v-if="isFetchingData">
        <SimpleLoader :size="64" :width="6" class="mx-auto my-20" />
      </template>
      <div v-else-if="statsReport" :class="$style.statsReports">
        <div
          v-for="(state, name, index) in statsReport"
          :key="name"
          :class="$style.reportItem"
        >
          <h3 :class="$style.h3">{{ name }}</h3>
          <TablePageShadowWrapper>
            <WeeklyReportTable :data="state || []" />
            <TablePageFooter
              v-if="state?.length"
              :total="state?.length"
              no-pages
            >
              <ExportAsCsvIconBtn
                @click="
                  // TODO
                  // @ts-expect-error
                  downloadCsv(state, `${name}_WeeklyReport`)
                "
              />
            </TablePageFooter>
          </TablePageShadowWrapper>
        </div>
      </div>
    </PageContentWrapper>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.weeklyReportView {
}
  .formWrapper {
    padding: 2.4rem 1.5rem 0.5rem 1.5rem;
    max-width: 1470px;
    margin: 2rem 0;
  }
  .statsReports {
    max-width: 1470px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: -30px;
  }
    .reportItem {
      width: calc(50% - 15px);
      min-width: 600px;
      margin-top: 30px;
    }
    .h3 {
      font-size: 18px;
      font-weight: 500;
      margin: 0 0 20px 0;
    }
</style>
